import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const AllowedWebsitesInfo = ({ webMonitoringData, deviceSelected, getLangTranslation }) => {
    const history = useHistory();
    const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
    const { appLanguageId } = useSelector(({ misc }) => misc);
    const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);

    return (
        <div
            className='g-col-12 g-col-lg-4'
            onClick={() => history.push({
                pathname: '/set-rules/allowed-websites', state: { device: deviceSelected }
            })}
        >
            <div className='d-flex align-items-center justify-content-center pt-cursor flex-wrap p-6 text-blue-400 border rounded-3 bg-gray-300 h-100 gap-3' >
                <i className='icon-check-fill fs-4 text-success border rounded-circle border-success' />
                <div className='d-flex flex-column'>
                    <span className='text-uppercase fw-bold d-flex align-items-center'>{getLangTranslation("WEB_MONITORING_ALLOWED_WEBSITES", "Allowed websites")}  <i className={`fs-5 ${lang?.isRTL === 1 ? 'icon-arrow-left' : 'icon-arrow-right'}`} /></span>
                    <p className='w-100 text-dark fw-semibold mb-0'>{webMonitoringData?.allowedWebsite?.length || 0} {getLangTranslation("REQUEST_SCREEN_WEBSITE", "websites")}</p>
                </div>
            </div>
        </div>
    )
}

export default AllowedWebsitesInfo